module.exports = __webpack_public_path__ + "img/PAMMAccountCardModel1.ad18ab0a.png";